import React, { FC } from 'react';
import styles from './modal_confirmation_footer.module.scss';

export const ModalConfirmationFooter: FC = ({ children }) => (
  <div className={styles.container}>{children}</div>
);
